import { isEmpty } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { useForm } from '~/hooks';
import { Card } from '~/components';
import FormSelect from '~/components/form/form-select';
import FormGroup from '~/components/form/form-group';
import FormPassword from '~/components/form/form-password';
import TryonExpressLogo from '~/assets/img/tryonexpress-logo.png';
import { MdCall, MdMailOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { auth } from '~/api';
import { auth as authUtil } from '~/util';

const RegisterPage = () => {

    const history = useHistory();
    const titles = [{
        'label': 'Attorney',
        'value': 'Attorney'
    },
    {
        'label': 'Paralegal',
        'value': 'Paralegal'
    },
    {
        'label': 'Abstractor',
        'value': 'Abstractor'
    },
    {
        'label': 'Legal Assistant',
        'value': 'Legal Assistant'
    }];

     
    const onSubmit = async ({ values, onFail, onInvalidForm, resetFormErrors }) => {
        try {
            resetFormErrors();
            let errors = {};
            if (!values.firstName) errors.firstName = 'First name is required';
            if (!values.lastName) errors.lastName = 'Last name is required';
            if (!values.userName) errors.userName = 'Username is required';
            if (values.userName.length < 5) errors.userName = 'Username must have a minimum of 5 characters';
            if (!values.title) errors.title = 'Title is required';
            if (!values.lawFirm) errors.lawFirm = 'Law Firm is required';
            if (!values.emailAddress) errors.emailAddress = 'Email address is required';
            if (!values.password) errors.password = 'Password is required';
            if (values.password !== values.confirmPassword) errors.confirmPassword = 'Password and Confirm password should match';
            if (!isEmpty(errors)) return onInvalidForm(errors);
            const response = await auth.registerUser(values);
            if(!response || response.errored){
                errors.formError = response.error || 'Registration failed';
                return onInvalidForm(errors);
            }else{
                history.push('/login');
            }
        } catch (e) {
            return onFail(e.message);
        }
    };

    const {
        state,
        formActions,
        fieldActions
    } = useForm({
        initialState: {
            firstName: '',
            lastName: '',
            lawFirm: '',
            title: '',
            emailAddress: '',
            userName: '',
            password:'',
            confirmPassword:''
        },
        onSubmit
    });

    return (
        <div className="lg:h-screen w-screen bg-gradient-to-b from-blue-50 to-blue-60 flex flex-col items-center justify-center p-8 md:p-12 lg:px-10 lg:py-36">
            <Card className="lg:h-screen flex flex-col lg:flex-row items-stretch w-11/12 lg:w-5/6 xl:w-2/3 justify-items-stretch">
                <div className="flex-1 xl:flex-initial bg-register bg-center bg-no-repeat bg-cover xl:w-1/3"/> 
                <section className="flex-1 xl:w-2/3 md:min-h-full flex flex-col items-stretch justify-center px-8 py-4 lg:py-8 lg:px-16">
                    <img src={TryonExpressLogo} className="h-12 md:h-16 self-start ml-1"/>
                    <p className="font-medium text-sm lg:text-base mb-4">Complete this form to request a Tryon Express account</p>
                    
                    <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-row gap-1 md:gap-2 xl:gap-4">
                        <FormGroup 
                            placeholder="First Name"
                            label="First Name"
                            path="firstName"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.firstName}
                            error={state.errors.firstName}
                            {...fieldActions}
                        />
                        <FormGroup 
                            placeholder="Last Name"
                            label="Last Name"
                            path="lastName"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.lastName}
                            error={state.errors.lastName}
                            {...fieldActions}
                        />                            
                        <FormGroup 
                            placeholder="Law Firm"
                            path="lawFirm"
                            label="Law Firm"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.lawFirm}
                            error={state.errors.lawFirm}
                            {...fieldActions}
                        />
                        <FormSelect
                            required
                            label="Title"
                            options={titles}
                            placeholder="Select a title"
                            groupClassName="col-span-1 text-xs lg:text-base md:text-sm "
                            inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                            path='title'
                            value={state.values.title}
                            error={state.errors.title}
                            {...fieldActions}
                        />
                        <FormGroup 
                            placeholder="Email Address"
                            label="Email Address"
                            path="emailAddress"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.emailAddress}
                            error={state.errors.emailAddress}
                            validator={value=>/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? true : state.values.emailAddress && 'Please provide a valid email'}                          
                            {...fieldActions}
                        />
                        <FormGroup 
                            placeholder="Username"
                            label="Username"
                            path="userName"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.userName}
                            error={state.errors.userName}
                            {...fieldActions}
                        />
                        <FormPassword 
                            placeholder="Password"
                            label="Password"
                            path="password"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.password}
                            error={state.errors.password}
                            validator={value=> authUtil.isStrongPassword(value) ? true : 'Password must include at least 8 characters, at least one digit, and at least one upper case character'}     
                            {...fieldActions}
                        />
                        <FormPassword 
                            placeholder="Confirm Password"
                            label="Confirm Password"
                            path="confirmPassword"
                            groupClassName="col-span-1"
                            inputClassName="text-xs lg:text-base md:text-sm w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.confirmPassword}
                            error={state.errors.confirmPassword}
                            {...fieldActions}
                        />
                    </div>
                    { state.errors.formError && (
                        <div className="my-4">
                            <p className="text-red-400 font-medium ml-2">{state.errors.formError}</p>
                        </div>
                    )}
                    <div className="flex items-center mt-4">
                        <button className="py-2 px-4 rounded-full text-xs lg:text-sm text-white bg-blue-50" onClick={() => formActions.submit()}>Submit</button>
                        <Link to="/login" className="ml-3 py-2 px-4 text-xs lg:text-sm rounded-full text-blueGray-100 bg-gray-100 font-semibold">
                            Cancel
                        </Link>
                    </div>
                    <footer className="mt-6">
                        <p className="text-xs lg:text-sm">Open M-F 8:00 AM to 8:00 PM, Saturday 9:00 AM to 1:00 PM</p>
                        <div className="flex items-center text-gray-400 text-xs lg:text-sm mt-1">
                            <a href='tel:9192770123' className="flex items-center mr-4">
                                <MdCall size="1.125rem" className="mr-1"/>
                                (919) 277-0123
                            </a>
                            <a href='mailto:orders@tryontitle.com' className="flex items-center">
                                <MdMailOutline size="1.125rem" className="mr-1"/>
                                orders@tryontitle.com
                            </a>
                        </div>
                    </footer>
                </section>
            </Card>
        </div>
    );
};

export default RegisterPage;